import { FluxoDoTitulo, FormDeTitulo } from '@/models'

export function criarTitulo(fluxo: FluxoDoTitulo): FormDeTitulo {
	return {
		dataDeVencimento: null,
		dataDeCompetencia: null,
		valor: null,
		pessoa: null ,
		fluxo: fluxo,
		situacao: 'Aberto',
		descricao: '',
		loja: null,
		formaDePagamento: null,
	}
}
